
export class SortHelper {
    static recursiveSort(data: any[], dir: 'asc' | 'desc') {
        if (data.length == 1) {
            for (const key of Object.keys(data[0])) {
                if (data[0][key] instanceof Array) data[0][key] = this.recursiveSort(data[0][key], dir);
            }
            return data;
        }
        else {
            const result = data.sort((a, b) => {
                for (const key of Object.keys(a)) { if (a[key] instanceof Array) a[key] = this.recursiveSort(a[key], dir); }
                for (const key of Object.keys(b)) { if (b[key] instanceof Array) b[key] = this.recursiveSort(b[key], dir); }

                if (a.order < b.order) return dir == 'asc' ? -1 : 1;
                else if (a.order > b.order) return dir == 'asc' ? 1 : -1;
                else return 0;
            });
            return result;
        }
    }
    static sort(data: any[], dir: 'asc' | 'desc') {
        const result = data.sort((a, b) => {
            if (a.order < b.order) return dir == 'asc' ? -1 : 1;
            else if (a.order > b.order) return dir == 'asc' ? 1 : -1;
            else return 0;
        });
        return result;
    }

    static copyProps(source, target) {
        for (let p in source) target[p] = source[p];
    }
}